import CallToAction from '@/components/elements/CallToAction';
import OurTeamBanner from '@/components/elements/OurTeamBanner';
import { SocialFeedbackItemProps } from '@/components/elements/SocialFeedbackItem';
import Spacer from '@/components/elements/Spacer';
import LandingBenefits from '@/components/modules/LandingBenefits';
import LandingIntro from '@/components/modules/LandingIntro';
import LandingLottieFour from '@/components/modules/LandingLottieFour';
import LandingLottieOne from '@/components/modules/LandingLottieOne';
import LandingLottieThree from '@/components/modules/LandingLottieThree';
import LandingLottieTwo from '@/components/modules/LandingLottieTwo';
import ResourcesCarousel from '@/components/modules/ResourcesCarousel';
import SocialFeedback from '@/components/modules/SocialFeedback';
import React from 'react';

export type LandingLayoutProps = {
  socialFeedback: SocialFeedbackItemProps[];
};

const LandingLayout = ({ socialFeedback }: LandingLayoutProps) => (
  <>
    <Spacer height={[50, null, 100]} />
    <LandingIntro />
    <Spacer height={[50, null, 100]} />
    <LandingBenefits />
    <Spacer height={[50, null, 100]} />
    <LandingLottieOne />
    <Spacer height={[50, null, 100]} />
    <LandingLottieTwo />
    <Spacer height={[50, null, 100]} />
    <LandingLottieThree />
    <Spacer height={[50, null, 100]} />
    <LandingLottieFour />
    <Spacer height={[50, null, 100]} />
    <SocialFeedback feedbacks={socialFeedback} />
    <Spacer height={[50, null, 100]} />
    {/* <Partners /> */}
    <OurTeamBanner />
    <Spacer height={100} />
    <ResourcesCarousel />
    <Spacer height={100} />
    <CallToAction />
    <Spacer height={100} />
  </>
);

export default LandingLayout;
